import { useQuery } from '@tanstack/react-query';
import { getAllActiveAndRemovedUsersAPI } from 'src/api';

export const useGetAllActiveAndRemovedUsers = () => {
  return useQuery({
    queryKey: ['all-active-and-removed-users'],
    queryFn: getAllActiveAndRemovedUsersAPI,
  });
};
